"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconGuideSize = void 0;
var React = __importStar(require("react"));
var IconGuideSize = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M9,9 C7.896,9 7,8.552 7,8 C7,7.448 7.896,7 9,7 C10.104,7 11,7.448 11,8 C11,8.552 10.104,9 9,9 Z M21,19 L21,14.004 C21,13.338 20.664,13 20.003,13 L9.5,13 C9.462,13 9.429,12.986 9.394,12.979 C9.263,12.984 9.133,12.993 9,12.993 C6.452,12.993 4.225,12.013 3,10.556 L3,16 C3,17.282 3.844,18.268 5,18.941 L5,17 L6,17 L6,19.422 C6.325,19.549 6.661,19.654 7,19.74 L7,17 L8,17 L8,19.931 C8.343,19.976 8.68,19.999 9,20 L9,16 L10,16 L10,20 L11,20 L11,18 L12,18 L12,20 L13,20 L13,18 L14,18 L14,20 L15,20 L15,16 L16,16 L16,20 L17,20 L17,18 L18,18 L18,20 L19,20 L19,18 L20,18 L20,20 L20.003,20 C20.25,20 21,20 21,19 Z M9,4 C5.691,4 3,5.792 3,7.996 C3,10.2 5.691,11.993 9,11.993 C12.309,11.993 15,10.2 15,7.996 C15,5.792 12.309,4 9,4 Z M15,12 L15,10.556 C14.526,11.119 13.904,11.609 13.17,12 L15,12 Z M20.003,12 C21.216,12 22,12.787 22,14.004 L22,19 C22,19.967 21.476,21 20.003,21 L20,21 L19,21 L18,21 L17,21 L16,21 L15,21 L14,21 L13,21 L12,21 L11,21 L10,21 L9.01,21 L9,21 C6.173,20.996 2,19.407 2,16 L2,8.5 C2,8.454 2.015,8.412 2.026,8.369 C2.014,8.245 2,8.122 2,7.996 C2,5.241 5.141,3 9,3 C12.492,3 15.388,4.837 15.908,7.228 C15.962,7.307 16,7.397 16,7.5 L16,12 L20.003,12 Z" }))); };
exports.IconGuideSize = IconGuideSize;
exports.IconGuideSize.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconGuideSize;
